import { FunctionComponent } from 'react'

import translate from '@i18n'
import MessageBox from '@components/RelatedMatches/MessageBox'
import { SvgIconName } from '@components/SvgIcon/types'

type SportEntitySchedulePlaceholderProps = {
  isDataEmpty: boolean
  error: Error | null
}

const SportEntitySchedulePlaceholder: FunctionComponent<
  SportEntitySchedulePlaceholderProps
> = ({ isDataEmpty, error }) => {
  const errorMessage = error
    ? {
        iconName: 'user-robot-xmarks-solid' as SvgIconName,
        title: translate('network.error.title'),
        text: translate('network.error.text'),
      }
    : isDataEmpty
      ? {
          iconName: 'calendar-clock' as SvgIconName,
          title: translate('sports.emptyData.title'),
          text: translate('sports.emptyData.text'),
        }
      : undefined

  return errorMessage ? (
    <MessageBox
      iconName={errorMessage.iconName}
      title={errorMessage.title}
      text={errorMessage.text}
    />
  ) : null
}

export default SportEntitySchedulePlaceholder
